export default __webpack_public_path__ + "static/media/entrega.fe11c5df.svg";